import React, { Fragment } from "react";
import PurchasedProductsList from "../components/PurchasedProductsList";
import ContractsProductsList from "../components/ContractsProductsList";
import _ from "lodash";
import DeleteProductFromShoppingCart from "../components/DeleteProductFromShoppingCart";

const MyShoppingCartPurchasedProducts = ({ shoppingCart }) => {
  return (
    <Fragment>
      <ContractsProductsList contracts={_.get(shoppingCart, "contracts", [])}>
        {({ contract }) => {
          return (
            <DeleteProductFromShoppingCart
              itemId={contract.tracking_number}
              productType="contract"
            />
          );
        }}
      </ContractsProductsList>
      <PurchasedProductsList
        purchasedProducts={_.get(shoppingCart, "purchased_products", [])}
      >
        {({ purchasedProduct }) => (
          <DeleteProductFromShoppingCart
            itemId={purchasedProduct.id.toString()}
            productType="product"
          />
        )}
      </PurchasedProductsList>
    </Fragment>
  );
};

export default MyShoppingCartPurchasedProducts;
